import DateOfBirthForm from "../../features/profile/components/DateOfBirthForm";
import { selectProfileByIdQueryOptions } from "@/features/profile/api/selectProfile";
import { OnboardingPatientPage } from "@/features/onboarding/components/OnboardingPatientPage";
import { useNavigateToNextOnboardingRoute } from "../../features/onboarding/hooks/useNavigateToNextOnboardingRoute";
import { useNavigateToPrevOnboardingRoute } from "../../features/onboarding/hooks/useNavigateToPrevOnboardingRoute";
import type { ProfileT } from "@patient-watch/types/database";
import { useAuth } from "@/utils/auth";
import { createFileRoute } from "@tanstack/react-router";

const DateOfBirth = () => {
    const auth = useAuth();
    const { profile } = Route.useLoaderData();
    const nextPage = useNavigateToNextOnboardingRoute("/onboarding/date-of-birth");
    const backPage = useNavigateToPrevOnboardingRoute("/onboarding/date-of-birth");

    return (
        <OnboardingPatientPage step="dateOfBirth">
            <DateOfBirthForm
                userId={auth.id}
                dateOfBirth={profile?.date_of_birth ?? ""}
                onSuccess={nextPage}
                onBack={backPage}
            />
        </OnboardingPatientPage>
    );
};
export const Route = createFileRoute("/onboarding/date-of-birth")({
    component: DateOfBirth,
    loader: async ({ context }) => {
        let profile: ProfileT | null = null;
        if (context?.auth?.id) {
            profile = await context?.queryClient.ensureQueryData(selectProfileByIdQueryOptions(context.auth.id));
        }
        return { profile };
    },
});
